import React, { useState } from "react";

import { connect } from "react-redux";

import RenderChart from "./RenderChart";
import InputsView from "./InputsView";
import Footer from "./Footer";
import OutputsView from "./OutputsView";
import { Custom_btn } from "./Custom_btn";

import AssumptionView from "./AssumptionView";

import { iconClick } from "./../helper/common-methods";

import { Custom_modal } from "@visualizeroi/vroi-custom-components";
import UserInfoModal from "./UserInfoModal";

const View = (props) => {
  const { outputs, decorate, currency_conversion_rate } = props;

  const [assumption_modal, setAssumption_modal] = useState(false);
  const [user_modal, setUser_modal] = React.useState(false);

  return (
    <>
      <div id="dvLoading" className={outputs ? "display_none" : ""}>
        <div className="loading-content">
          <h3 id="scriptId_missing" style={{ fontWeight: 700 }}></h3>
          <i
            style={{ color: "#0057B7" }}
            className=" fa fa-spinner fa-spin fa-5x"
            aria-hidden="true"
          ></i>
        </div>
      </div>
      <div className="container custom_container ">
        <div className="row  plr0 space_between">
          <div className="left_side">
            <div className="input_section">
              <InputsView />
            </div>
          </div>

          <div className="right_side">
            <OutputsView
              setAssumption_modal={setAssumption_modal}
              setUser_modal={setUser_modal}
            />
          </div>
        </div>

        <Custom_modal
          show={assumption_modal}
          setOpen={() => {}}
          className="custom-modal3"
        >
          <AssumptionView setAssumption_modal={setAssumption_modal} />
        </Custom_modal>

        <div className="">
          {/* <Footer /> */}
          <div className="report_btn_div" id="modal_user_info">
            <Custom_modal
              show={user_modal}
              setOpen={() => {}}
              className="custom-modal2"
            >
              <UserInfoModal setUser_modal={setUser_modal} />
            </Custom_modal>
          </div>
          <div id="iframe-div"></div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state, ownProps) {
  const { widget_reducer } = state;
  return {
    ...ownProps,
    outputs: widget_reducer.visualizer_input_output_values
      ? widget_reducer.visualizer_input_output_values.outputs
      : {},
    decorate: widget_reducer.decorate,
    currency_conversion_rate: widget_reducer.currency_conversion_rate,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
